import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  applicationRelated: 'Application related',
  deviceMonitoringManagement: 'Device monitoring/management',
  firmwareManagement: 'Firmware management',
  subscriptionManagement: 'Subscription management',
  api: 'API',
  other: 'Other',
  // localGatewayConnectivity: 'Local gateway connectivity',
};
